import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams } from '../types';
import META from './useTrackCreditMeterUpsellClicked.meta';

export type UseTrackCreditMeterUpsellClickedParams = CreditAnalyticsParams;

export const useTrackCreditMeterUpsellClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreditMeterUpsellClicked = useCallback(
    (params: UseTrackCreditMeterUpsellClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCreditMeterUpsellClicked };
};
